var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionalServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 97,
    rx: 8.5,
    fill: "white",
    stroke: "#339999",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.375 55.164H52.125C53.3848 55.164 54.593 54.6548 55.4838 53.7483C56.3746 52.8419 56.875 51.6125 56.875 50.3306C56.875 49.0488 56.3746 47.8194 55.4838 46.913C54.593 46.0065 53.3848 45.4973 52.125 45.4973H45C43.575 45.4973 42.3875 45.9806 41.675 46.9473L28.375 59.9973",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.875 69.664L41.675 66.2807C42.3875 65.314 43.575 64.8307 45 64.8307H54.5C57.1125 64.8307 59.4875 63.864 61.15 61.9307L72.075 51.2973C72.9915 50.416 73.5264 49.2004 73.562 47.9178C73.5976 46.6352 73.1311 45.3907 72.265 44.4582C71.3989 43.5256 70.2042 42.9813 68.9437 42.945C67.6832 42.9088 66.4602 43.3835 65.5437 44.2648L55.5687 53.6898",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 57.5806L40.25 72.0806",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5625 41.8722C69.225 40.1806 71.125 38.0056 71.125 35.3472C71.291 33.8705 70.962 32.3799 70.1915 31.1172C69.4209 29.8544 68.2538 28.8935 66.8794 28.39C65.505 27.8865 64.0038 27.8701 62.619 28.3433C61.2343 28.8165 60.0471 29.7517 59.25 30.9972C58.4022 29.8483 57.2147 29.0062 55.8619 28.5945C54.5091 28.1829 53.0623 28.2234 51.7338 28.71C50.4053 29.1967 49.2651 30.1039 48.4806 31.2985C47.6961 32.493 47.3086 33.9121 47.375 35.3472C47.375 38.2472 49.275 40.1806 50.9375 42.1139L59.25 50.3306L67.5625 41.8722Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalServices);
export default __webpack_public_path__ + "static/media/ProfessionalServices.930ad8cc4911b2058283291d97f298f8.svg";
export { ForwardRef as ReactComponent };